import React from 'react'

import { TypographyPropsBasic } from './Typography.model'
import { StyledTypography } from './Typography.styled'

export interface TypographyProps extends TypographyPropsBasic {
  ref?: React.Ref<any>
}

const Typography = ({ children, onClick, ref, variant, ...rest }: React.PropsWithChildren<TypographyProps>) =>  (
  <StyledTypography
    as={variant}
    ref={ref}
    variant={variant}
    onClick={onClick}
    {...rest}
  >
    {children}
  </StyledTypography>
)

export default Typography
